export default {
  namespaced  : true,
  
  state       : {
    isEditorLoading         : false,
    isOpenEditEditorModal   : false
  },

  mutations   : {
    setIsEditorLoading(state, payload){
      state.isEditorLoading = payload.value;
    },

    setIsOpenEditEditorModal(state, value){
      state.isOpenEditEditorModal = value;
    },
    
    resetStore(state){
      state.isEditorLoading       = false;
      state.isOpenEditEditorModal = false;
    }
  },

  actions     : {
    updateIsEditorLoading(context, payload){
      context.commit('setIsEditorLoading', payload);
    },
    
    updateIsOpenEditEditorModal(context, payload){
      context.commit('setIsOpenEditEditorModal', payload.value);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}